import React, { useState, useEffect } from 'react';
import { supabase } from '../supabaseClient';
import { FaLink, FaMapMarkerAlt } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const BusinessesList = () => {
  const [businesses, setBusinesses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [pageSize, setPageSize] = useState(6);  // عدد السجلات في الصفحة

  // جلب البيانات من قاعدة البيانات عند تغيير الصفحة
  useEffect(() => {
    const fetchBusinesses = async () => {
      try {
        const { count, data, error } = await supabase
          .from('businesses')
          .select('*', { count: 'exact' }) // جلب العدد الإجمالي للسجلات
          .range((currentPage - 1) * pageSize, currentPage * pageSize - 1);  // تحديد نطاق البيانات حسب الصفحة

        if (error) throw error;

        setBusinesses(data);
        setTotalPages(Math.ceil(count / pageSize)); // حساب العدد الإجمالي للصفحات
      } catch (error) {
        console.error('حدث خطأ أثناء جلب البيانات:', error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchBusinesses();
  }, [currentPage, pageSize]); // إعادة جلب البيانات عندما يتغير رقم الصفحة أو حجم الصفحة

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <span className="text-xl text-gray-700">جارٍ تحميل المحلات...</span>
      </div>
    );
  }

  // تغيير الصفحة
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  return (
    <div className="min-h-screen bg-[#F2F2F7] py-8">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl font-bold text-center mb-8 text-[#292260]">المحلات</h2>

        {/* زر إضافة محل جديد */}
        <div className="text-right mb-6">
          <Link
            to="/add-business"
            className="bg-[#292260] text-white py-2 px-4 rounded-full hover:bg-[#3b2d7e] transition duration-300"
          >
            أضف محلك إلى القائمة
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {businesses.map((business) => (
            <div
              key={business.id}
              className="bg-white rounded-lg shadow-lg overflow-hidden"
            >
              {/* عرض الشعار داخل دائرة */}
              <div className="flex justify-center mt-4">
                {business.logo_url ? (
                  <img
                    src={business.logo_url}
                    alt={business.name}
                    className="w-24 h-24 object-cover rounded-full"
                  />
                ) : (
                  <div className="w-24 h-24 bg-gray-200 flex justify-center items-center rounded-full">
                    <span className="text-gray-500">لا يوجد شعار</span>
                  </div>
                )}
              </div>

              {/* محتوى البطاقة */}
              <div className="p-4">
                <h3 className="text-xl font-semibold text-[#292260] truncate">{business.name}</h3>
                <div className="mt-2 mb-4">
                  <span className="bg-[#292260] text-white px-4 py-1 inline-block rounded-full">
                    {business.category}
                  </span>
                </div>
                {business.description && (
                  <p className="text-sm text-gray-600 mt-2">{business.description}</p>
                )}
                <p className="text-sm text-gray-500 mt-2">
                  <FaMapMarkerAlt className="inline mr-2 text-[#292260]" />
                  {business.address}
                </p>
                {business.website && (
                  <p className="text-sm text-[#292260] mt-2">
                    <FaLink className="inline mr-2 text-[#292260]" />
                    <a href={business.website} target="_blank" rel="noopener noreferrer">
                      زيارة الموقع
                    </a>
                  </p>
                )}
              </div>
            </div>
          ))}
        </div>

        {/* أزرار التنقل بين الصفحات */}
        <div className="flex justify-center mt-6">
          <button
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
            className="bg-[#292260] text-white py-2 px-4 rounded-full mr-4 disabled:opacity-50"
          >
            السابق
          </button>
          <span className="text-lg text-[#292260]">
            صفحة {currentPage} من {totalPages}
          </span>
          <button
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            className="bg-[#292260] text-white py-2 px-4 rounded-full ml-4 disabled:opacity-50"
          >
            التالي
          </button>
        </div>
      </div>
    </div>
  );
};

export default BusinessesList;
